import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FiSmartphone } from 'react-icons/fi';
import favicon from '../assets/favicon.png';
import { dialerCrmRequest, getDialerCrmSession, savePendingOtp, requestError } from '../utils/dialerCrmApi';

export default function Home() {
    const [mobile, setMobile] = useState('');
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (getDialerCrmSession()) navigate('/dashboard', { replace: true });
    }, [navigate]);

    const submit = async event => {
        event.preventDefault();
        setValidated(true);
        if (loading || !event.currentTarget.checkValidity()) return;
        setLoading(true);
        try {
            const response = await dialerCrmRequest('send-otp', { mobile });
            if (response.status !== 1) { toast.error(response.msg); return; }
            savePendingOtp(mobile, response.data);
            toast.success(response.msg);
            navigate('/mobile-otp');
        } catch (error) {
            toast.error(requestError(error));
        } finally {
            setLoading(false);
        }
    };

    return <div className="homePage">
        <Helmet><title>Satkartar | Dialer with CRM Login</title></Helmet>
        <div className="auth-shell"><div className="user_card"><div className="auth-card-inner">
            <div className="auth-header">
                <div className="brand_logo_container"><img src={favicon} className="brand_logo" alt="Satkartar logo" /></div>
                <h1 className="loginname">LOGIN</h1>
                <p className="auth-subtitle">LEAD PUSH DIALER WITH CRM</p>
                <span className="auth-pill"><FiSmartphone /> MOBILE LOGIN</span>
            </div>
            <div className="form_container">
                <Form noValidate validated={validated} onSubmit={submit}>
                    <Form.Group controlId="mobile" className="mobileinput">
                        <Form.Label>MOBILE NUMBER</Form.Label>
                        <div className="auth-input-wrap"><FiSmartphone />
                            <Form.Control required type="tel" inputMode="numeric" autoComplete="tel-national"
                                placeholder="Enter your 10-digit mobile" name="mobile" value={mobile}
                                onChange={event => setMobile(event.target.value.replace(/\D/g, '').slice(0, 10))}
                                pattern="[6-9][0-9]{9}" maxLength={10} disabled={loading} />
                        </div>
                        <Form.Control.Feedback type="invalid">Please enter a valid 10-digit mobile number.</Form.Control.Feedback>
                    </Form.Group>
                    <div className="login_container"><button disabled={loading} type="submit" className="btn login_btn">
                        {loading ? 'SENDING OTP...' : 'SEND MOBILE OTP'}
                    </button></div>
                </Form>
            </div>
            <p className="auth-footer">&copy; 2026 Sat Kartar Life Limited.</p>
        </div></div></div>
    </div>;
}
